import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DownloadBillingAndSoaForm } from '@/components/forms/DownloadBillingAndSoaForm'
import {
  shippingLineNameFromSearchParams,
  soaIdFromSearchParams,
} from '@/lib/navigation/financialStatementsSearchParams'

export default function DownloadBillingAndSoaPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const params = useParams<{ shippingLineId: string; billingId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementId = params.billingId ? parseInt(params.billingId, 10) : undefined

  const finalShippingLineId = paramsShippingLineId
  const finalBillingStatementId = billingStatementId
  const finalSoaId = soaIdFromSearchParams(searchParams)
  const shippingLineName = shippingLineNameFromSearchParams(searchParams)

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Download Billing Statement and SOA
            </Heading>
          </CardHeader>
          <CardBody>
            <DownloadBillingAndSoaForm
              shippingLineId={finalShippingLineId || ''}
              shippingLineName={shippingLineName}
              billingStatementId={finalBillingStatementId}
              soaId={finalSoaId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
